// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "/* Variables */\n[data-v-2d2bbdc2]:export {\n  menuBg: #304156;\n  menuText: #bfcbd9;\n  menuActiveText: #409EFF;\n}\n\n/* Mixins */\n.svg-icon[data-v-2d2bbdc2] {\n  margin-right: 16px;\n}\n.simple-mode .svg-icon[data-v-2d2bbdc2] {\n  margin-left: 20px;\n}", ""]);
// Exports
module.exports = exports;
